function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "34",
  height: "24",
  viewBox: "0 0 34 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: ".5",
  y: ".5",
  width: "33",
  height: "23",
  rx: "3.5",
  fill: "#fff",
  stroke: "#D9D9D9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.614 18.448l.22-1.449-.49-.012h-2.349l1.632-10.693a.143.143 0 01.045-.084.131.131 0 01.088-.033h3.958c1.315 0 2.222.282 2.695.84.223.262.364.536.432.837.072.315.073.693.003 1.153l-.005.034v.295l.222.13c.187.102.336.22.45.354.19.224.312.508.364.845.054.347.036.76-.052 1.227-.1.537-.265 1.006-.486 1.389a2.822 2.822 0 01-.77.872c-.294.215-.643.38-1.038.484a5.017 5.017 0 01-1.296.155h-.308a.916.916 0 00-.602.229.972.972 0 00-.315.579l-.023.13-.39 2.555-.017.093c-.005.03-.013.045-.025.055a.064.064 0 01-.04.015h-1.903z",
  fill: "#28356A"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.276 9.075a7.3 7.3 0 01-.04.24c-.523 2.77-2.31 3.727-4.59 3.727h-1.162a.57.57 0 00-.557.494l-.764 5.003a.304.304 0 00.294.355h2.06a.501.501 0 00.49-.431l.02-.108.388-2.545.024-.14a.5.5 0 01.49-.432h.308c1.996 0 3.559-.838 4.015-3.261.191-1.013.092-1.858-.412-2.453a1.979 1.979 0 00-.564-.45z",
  fill: "#298FC2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.73 8.85a3.991 3.991 0 00-.509-.117 6.253 6.253 0 00-1.023-.077h-3.104a.48.48 0 00-.214.05.51.51 0 00-.275.383l-.66 4.321-.019.126a.57.57 0 01.558-.494h1.161c2.282 0 4.068-.957 4.59-3.727a6.17 6.17 0 00.04-.24 2.726 2.726 0 00-.546-.225z",
  fill: "#22284F"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.605 9.089a.508.508 0 01.276-.382.48.48 0 01.214-.05h3.103c.367 0 .71.024 1.024.077a4.557 4.557 0 01.507.116l.118.038c.154.052.297.115.429.187.155-1.024-.001-1.721-.537-2.353-.59-.695-1.656-.992-3.02-.992H13.76a.572.572 0 00-.56.494l-1.648 10.804a.348.348 0 00.335.406h2.445l1.273-8.345z",
  fill: "#28356A"
})));